module.exports = __webpack_public_path__ + "img/kraken_cointreasure.5308bef.png";